







import {Component, Prop, Vue} from 'vue-property-decorator'

@Component({
  components: {},
  name: 'CircleStatus',
})
export default class CircleStatus extends Vue {
  @Prop() private color!: string

  get background(): string {
    return 'background-color: ' + (this.color ? this.color : 'yellow') + ';'
  }

}
